import { useAppDispatch } from "@/core/app/hooks"
import { ContourMachineType } from "@/core/app/slices/user/user.type"
import { Box } from "@mui/material"
import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormLabel from "@mui/material/FormLabel"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

export const TrimLine = ({
  currPrint,
  updateModel,
}) => {
  const { t } = useTranslation("common")
  const dispatch = useAppDispatch()
  const [trimValue, setTrimValue] = useState<ContourMachineType>(
    ContourMachineType.DigitalDental,
  )

  const handleTrimValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(event.target.value) as ContourMachineType
    setTrimValue(value)
    dispatch(updateModel({ UseuContourMachine: value }))
  }

  useEffect(() => {
    setTrimValue(currPrint?.UseuContourMachine)
  }, [currPrint?.UseuContourMachine])
  return (
    <Box sx={{ width: "100%" }}>
      <FormControl sx={{ marginRight: "240px" }}>
        <FormLabel id="toothPosition">{t(`stlPrinting.trimMachine`)}</FormLabel>
        <RadioGroup
          sx={{ marginLeft: "10px" }}
          aria-labelledby="toothPosition"
          name="radio-buttons-group"
          value={trimValue}
          onChange={handleTrimValue}
        >
          <FormControlLabel
            value={ContourMachineType.DigitalDental}
            control={<Radio />}
            label={t(`stlPrinting.trimLabel1`)}
          />
          <FormControlLabel
            value={ContourMachineType.GeneralTrimming}
            control={<Radio />}
            label={t(`stlPrinting.trimLabel2`)}
          />
          <FormControlLabel
            value={ContourMachineType.NoTrim}
            control={<Radio />}
            label={t(`stlPrinting.trimLabel3`)}
          />
        </RadioGroup>
      </FormControl>
    </Box>
  )
}
